import { defineEvent } from '../types/event';
export var COUPON_MODAL_EMAIL_LIST_FAIL = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        },
        {
            name: 'Heap',
            alias: 'coupon-modal_email-failure'
        }
    ]
});
